import React from 'react'
import { Link } from 'react-router-dom'
import { Font } from 'components'
import cx from 'classnames'
import styles from '../styles.module.scss'

const SweepstakesRules = props => {
  return (
    <>
      <Font type="heading" weight="bold" className={cx(styles.title, 'mb-32')}>
        Recon Sweepstakes Rules
      </Font>

      <Font type="bodyLato" className="mb-16">
        These rules, along with the information regarding ongoing Sweepstakes
        provided on the Recon sweepstakes page or sent to you directly via email
        (
        <Link className={styles.link} to="/sweepstakes">
          here
        </Link>
        ) (the “Sweepstakes Page”) (collectively “Sweepstakes Rules”) are the
        complete, official rules for any Recon Sweepstakes. Sponsor reserves the
        right to disqualify any Participant who is found to breach these
        Sweepstakes Rules.
      </Font>
      <Font type="bodyLato" className="mb-16">
        The Sweepstakes is sponsored by Recon Technologies, Inc., located at
        3019 Wilshire Boulevard, Unit 317, Santa Monica, California, 90403
        (“Recon” or “Sponsor”).
      </Font>
      <Font type="bodyLato" className="mb-16">
        <b>SWEEPSTAKES PERIOD:</b> Beginning on the Sweepstakes Start Date
        (provided on the Sweepstakes Page), each Sweepstakes will be open to
        receive Submissions at 12:00:01 A.M. Pacific Time (“PT”) and close to
        Submissions on the Sweepstakes End Date (provided on the Sweepstakes
        Page) at 11:59:59 P.M. PT (the “Submission Period”). Submissions
        received after the Submission Period will not be considered valid
        submissions.
      </Font>
      <Font type="bodyLato" className="mb-16">
        It is the Participant's responsibility to check the Sweepstakes Page
        regularly throughout the Sweepstakes to stay informed of any new or
        updated deadlines. Recon is not responsible for any Participant's
        failure to do so.
      </Font>

      <Font type="bodyLato" className="mb-16">
        Note: Sponsor’s computer is the official timekeeping device for this
        Sweepstakes.
      </Font>
      <Font type="bodyLato" className="mb-16">
        ELIGIBILITY: The Sweepstakes is open only to legal permanent residents
        of: the fifty (50) United States and the District of Columbia
        (excluding, without limitation, Puerto Rico, other U.S. territories and
        possessions, and where prohibited by law), who are 18 years of age or
        older. The following individuals are not eligible to participate or to
        submit Submissions: (i) employees of Recon, and any of their affiliate
        companies or subsidiaries; (ii) family members (spouse, parents,
        siblings and children) of any individual referred to in clause (i), and
        (iii) persons living in the same household (whether or not related) with
        any person referred to in clause (i) or (ii) above. This Sweepstakes is
        subject to all federal, state, and local laws and regulations and is
        void outside the United States and where prohibited by law.
      </Font>

      <Font type="bodyLato" className="mb-16">
        Recon is the sole judge of eligibility and may determine that a
        Submission or Participant is ineligible to participate in the
        Sweepstakes for a variety of reasons not described here but at the sole
        discretion of Recon.
      </Font>
      <Font type="bodyLato" className="mb-16">
        <b>AGREEMENT TO OFFICIAL RULES:</b> Entrant’s participation in the
        Sweepstakes constitutes Entrant’s full and unconditional agreement to
        and acceptance of these Official Rules and the decisions of Sponsor,
        which are final and binding. By participating in the Sweepstakes and
        submitting a Submission, Participant expressly agrees to participate in
        supporting marketing and other promotions and endorsements for Recon and
        its partners. Recon may display Submission photos, videos or other
        content on its website or on other promotional materials without
        attribution or any compensation owed to Participant.
      </Font>
      <Font type="bodyLato" className="mb-16">
        <b>SUBMISSION REQUIREMENTS: HOW TO ENTER:</b> You may enter the
        sweepstakes in two ways: (1) as provided on the Sweepstakes Page; or (2)
        mailing a submission containing your name, address and telephone number
        to: Attn: Sweepstakes Entry, 3019 Wilshire Boulevard, Unit 317, Santa
        Monica, California, 90403 (“Mailed Submissions”). Mailed Submissions
        will be dated as submissions on the date they are received. Mailed
        submissions received after the Submission Period for will not be
        considered valid submissions.
      </Font>
      <Font type="bodyLato" className="mb-16">
        All submissions will be given equal weight when selecting a winner. No
        purchase is necessary to enter. One entry per Eligible Participant per
        Submission Period.
      </Font>
      <Font type="bodyLato" className="mb-16">
        Submissions must be received prior to the Sweepstake deadline and adhere
        to the guidelines for Submissions specified on the Sweepstakes Page.
      </Font>
      <Font type="bodyLato" className="mb-16">
        Submissions that do not meet the requirements set forth in these
        Official Rules and the Sweepstakes Page, in the sole discretion of
        Sponsor, will be void and ineligible for a prize.
      </Font>
      <Font type="bodyLato" className="mb-16">
        <b>PRIZES AND APPROXIMATE RETAIL VALUE (“ARV”):</b> The prize and its
        approximate retail value for each Sweepstakes will be provided on the
        Sweepstakes Page. Prizes will vary depending upon the ongoing
        Sweepstakes and are only awarded to Submissions that were submitted
        during the Submission Period for a particular Sweepstakes.
      </Font>
      <Font type="bodyLato" className="mb-16">
        Each prize is nontransferable and non-refundable and must be accepted as
        awarded. No cash or other substitution may be made except by Sponsor,
        who reserves the right to substitute a prize with another prize of equal
        or greater value for any reason as determined by Sponsor in its sole
        discretion. All other costs and expenses not specifically mentioned
        herein, Winner will be responsible for all applicable federal and local
        taxes on the receipt and use of the prize
      </Font>
      <Font type="bodyLato" className="mb-16">
        <b>SELECTION OF POTENTIAL WINNERS:</b> On the date provided on the
        Sweepstakes Page, the winner(s) will be selected in a random drawing.
        All drawings will be made on a strictly random basis. Winners will be
        notified by a comment on the entry post on the Wednesday following the
        drawing. Odds of winning prizes depend on the number of eligible entries
        received during Entry Period. All entries are subject to verification
        and approval by the Sponsor. All decisions regarding prize awards will
        be made by Sponsor and are final and binding. In the event of
        noncompliance with these Official Rules and Regulations, or if the prize
        is unclaimed or returned as undeliverable, the prize will be forfeited
        and may be awarded to an alternate winner drawn from remaining eligible
        entries.
      </Font>
      <Font type="bodyLato" className="mb-16">
        Sponsor shall not be responsible for lost, late, misdirected, damaged,
        illegible, incomplete, garbled, or incorrect entries. Entries become the
        property of Sponsor and will not be returned. Participation constitutes
        acceptance of these Official Rules in their entirety. Participant
        warrants that it is eligible to participate in the Sweepstakes and
        agrees to indemnify and hold harmless Sponsor from any loss, damage or
        expense arising out of or in connection with participation in this
        Sweepstakes or the acceptance, use or misuse of any prize.
      </Font>
      <Font type="bodyLato" className="mb-16">
        <b>WINNERS' OBLIGATIONS (DELIVERY & DOCUMENTATION):</b> Before being
        declared a winner the selected Participant may be contacted by email and
        notified that they are eligible to win. The selected Participant must
        reply within one (1) business day of notification and provide the
        Sponsor with a contact phone number, email and address. The Sponsor will
        then email the Winner and he/she will be required to sign and return
        within one (1) business day of notification a declaration of eligibility
        and a liability/publicity release, which:
      </Font>
      <ol type="a">
        <li>
          <Font type="bodyLato" className="mb-8">
            confirms compliance with the Sweepstakes rules;
          </Font>
        </li>
        <li>
          <Font type="bodyLato" className="mb-8">
            releases the Sponsor, its affiliated companies and agents,
            advertising and promotion agencies, the Sweepstakes judges and each
            of their respective officers, directors, agents, representatives,
            successors and assigns from any liability in connection with the
            Sweepstakes, the entrant’s participation therein and/or the awarding
            and use or misuse of the prize or any portion thereof; and
          </Font>
        </li>
        <li>
          <Font type="bodyLato" className="mb-8">
            grants to the Sponsor the right to use the selected entrant’s name,
            address and likeness in any form of advertising relating to the
            Sweepstakes without further notice or compensation.
          </Font>
        </li>
      </ol>

      <Font type="bodyLato" className="mb-16">
        If a selected Participant: (i) cannot be contacted by email within one
        (1) calendar days of selection or there is a return of any prior
        notification as undeliverable; or (ii) fails to return the Sweepstakes
        documents within the specified time, then he/she will be disqualified
        and will forfeit the prize, and the Sponsor reserves the right to select
        an alternate entrant from among the remaining eligible entries.
      </Font>
      <Font type="bodyLato" className="mb-16">
        A Participant may decline to be a Winner by notifying Sponsor within one
        business day following notification, in which case the declining
        Participant forgoes any prize or other features associated with winning
        the Sweepstakes. Sponsor reserves the right to disqualify a Participant
        if Sponsor deems disqualification appropriate.
      </Font>
      <Font type="bodyLato" className="mb-16">
        Sweepstakes winner will be announced on the Sweepstakes Page on the date
        provided on the Sweepstakes Page.
      </Font>
      <Font type="bodyLato" className="mb-16">
        If a prize is valued at $600 or more the potential winner must also sign
        and return an IRS W-9 form, within the stated time in order to claim the
        prize.
      </Font>
      <Font type="bodyLato" className="mb-16">
        Potential winners will be disqualified and the prize may be awarded to
        an alternate winner (the next-ranked qualified Participant on the
        leaderboard) if:
      </Font>

      <ul>
        <li>
          <Font type="bodyLato" className="mb-16">
            the required documentation is not returned within 14 days after
            receipt of any request to provide documentation;
          </Font>
        </li>
        <li>
          <Font type="bodyLato" className="mb-16">
            prize notification letter/email or prize is returned as
            undeliverable; or
          </Font>
        </li>
        <li>
          <Font type="bodyLato" className="mb-16">
            potential winner is disqualified for any reason.
          </Font>
        </li>
      </ul>

      <Font type="bodyLato" className="mb-16">
        By accepting any Prize, each Participant receiving a Prize thereby
        agrees to use of his/her name, address, likeness and/or Prize
        information by Recon for promotional purposes in any medium without
        additional compensation
      </Font>
      <Font type="bodyLato" className="mb-16">
        <b>DECLINING PRIZES:</b> A Participant may decline to be a Winner by
        notifying Recon directly within one week following the Sweepstakes
        deadline, in which case the declining Participant forgoes any prize or
        other features associated with winning the Sweepstakes. Recon reserves
        the right to disqualify a Participant if Recon deems disqualification
        appropriate.
      </Font>
      <Font type="bodyLato" className="mb-16">
        <b>RECEIVING PRIZES:</b> After verification of eligibility, each Prize
        winner will receive the prize through U.S. Mail or via email, as
        appropriate. Allow 30 days from final confirmation for Prize delivery.
        Any winners that receive prizes valued over $600 will receive IRS 1099
        form in the amount of their prize at the appropriate time. Prize winners
        are responsible for any taxes, fees or other liability resulting from
        their receipt of a Prize regardless of the value of the prize.
      </Font>
      <Font
        type="bodyLato"
        weight="bold"
        className={cx(styles.centerAlign, 'mb-16')}
      >
        WARRANTIES AND OBLIGATIONS
      </Font>
      <Font type="bodyLato" className="mb-16">
        <b>PARTICIPANT WARRANTIES AND OBLIGATIONS:</b> By registering or
        submitting a Submission, you agree that you have full right and
        authority to submit the Submission. You are solely responsible for your
        Submission. All registration information is deemed collected in the
        United States.
      </Font>
      <Font type="bodyLato" className="mb-16">
        Participation is subject to all federal, state and local laws and
        regulations. Void where prohibited or restricted by law. You are
        responsible for checking applicable laws and regulations in your
        jurisdiction before participating in the Sweepstakes to make sure that
        your participation is legal. You are responsible for all taxes and
        reporting related to any award that you may receive as part of the
        Sweepstakes.
      </Font>
      <Font type="bodyLato" className="mb-16">
        Each Participant is solely responsible for all equipment, including but
        not necessarily limited to a camera, computer and internet connection
        necessary to access the Website and to develop and upload any
        Submission, as well as all costs incurred by or behalf of the Entrant in
        participating in the Sweepstakes.
      </Font>
      <Font type="bodyLato" className="mb-16">
        By entering a Submission, you represent and warrant that you have the
        right and authority to make the Submission on your own behalf and that
        your Submission:
      </Font>

      <ul>
        <li>
          <Font type="bodyLato" className="mb-16">
            is your own original work;
          </Font>
        </li>
        <li>
          <Font type="bodyLato" className="mb-16">
            does not contain confidential information;
          </Font>
        </li>
        <li>
          <Font type="bodyLato" className="mb-16">
            does not violate or infringe upon the intellectual property rights,
            copyrights, trademarks, rights of privacy, publicity or other
            intellectual property or other rights of any person or entity;
          </Font>
        </li>
        <li>
          <Font type="bodyLato" className="mb-16">
            does not and will not violate any applicable law, statute,
            ordinance, rule or regulation; and
          </Font>
        </li>
        <li>
          <Font type="bodyLato" className="mb-16">
            does not trigger any reporting or royalty obligation to any third
            party
          </Font>
        </li>
      </ul>

      <Font type="bodyLato" className="mb-16">
        A breach of any of these warranties will result in the corresponding
        Submission being invalid.
      </Font>

      <Font type="bodyLato" className="mb-16">
        <b>LIMITATION OF LIABILITY:</b> By participating in the Sweepstakes,
        each Participant agrees to release, indemnify and hold harmless Recon,
        their respective affiliates, subsidiaries, advertising and promotions
        agencies, as applicable, and each of their respective agents,
        representatives, officers, directors, shareholders, and employees from
        and against any injuries, losses, damages, claims, actions and any
        liability of any kind resulting from or arising out of your
        participation in or association with the Sweepstakes. Sweepstakes
        Sponsor is not responsible for any miscommunications such as technical
        failures related to computer, telephone, cable, and unavailable network
        or server connections, related technical failures, or other failures
        related to hardware, software or virus, or incomplete, late or
        misdirected Submissions. Sweepstakes Sponsor reserves the right to
        cancel, modify or suspend the Sweepstakes should any computer virus, bug
        or other technical difficulty or other causes beyond the control of
        Sweepstakes Sponsor corrupt the administration, security or proper play
        of the Sweepstakes, and to determine winners from among Submission not
        affected by the corruption, if any, in its sole discretion.
      </Font>
      <Font type="bodyLato" className="mb-16">
        Recon is not responsible for (a) late, lost, stolen, damaged, garbled,
        incomplete, incorrect or misdirected Submissions or other
        communications, (b) errors, omissions, interruptions, deletions,
        defects, or delays in operations or transmission of information, in each
        case whether arising by way of technical or other failures or
        malfunctions of computer hardware, software, communications devices, or
        transmission lines, or (c) data corruption, theft, destruction,
        unauthorized access to or alteration of Submission materials, loss or
        otherwise. Recon is not responsible for electronic communications or
        emails which are undeliverable as a result of any form of active or
        passive filtering of any kind, or insufficient space in any email
        account to receive email messages. Sweepstakes Sponsor disclaims any
        liability for damage to any computer system resulting from participation
        in, or accessing or downloading information in connection with, the
        Sweepstakes.
      </Font>
      <Font type="bodyLato" className="mb-16">
        <b>RESERVATION OF RIGHTS:</b> Sweepstakes Sponsor reserves the right to
        modify the Start Date, End Date, and the right to modify, add or remove
        additional Sweepstakes deadlines for any reason. Any changes will be
        communicated through the Sweepstakes Website.
      </Font>

      <Font
        type="bodyLato"
        weight="bold"
        className={cx(styles.centerAlign, 'mb-16')}
      >
        MISCELLANEOUS
      </Font>
      <Font type="bodyLato" className="mb-16">
        <b>PRIVACY:</b> Participants agree that personal data submitted and any
        other information provided in connection with the Sweepstakes may be
        processed, shared, and otherwise used for the purposes and within the
        context of the Sweepstakes and any other purposes outlined in these
        Official Rules and the Privacy Policy found at [
        <Link className={styles.link} to="/privacy">
          rules
        </Link>
        ].
      </Font>
      <Font type="bodyLato" className="mb-16">
        In addition to the uses of personal information described in that
        Policy, Sponsor will use information you provide through entry into the
        Sweepstakes to administer the Sweepstakes.
      </Font>
      <Font type="bodyLato" className="mb-16">
        <b>SEVERABILITY:</b> The invalidity or un-enforceability of any
        provision of these Sweepstakes Rules shall not affect the validity or
        enforceability of any other provision. In the event that any provision
        is determined to be invalid or otherwise unenforceable or illegal, these
        Sweepstakes Rules shall otherwise remain in effect and be construed in
        accordance with their terms as if the invalid or illegal provision was
        not contained herein.
      </Font>
      <Font type="bodyLato" className="mb-16">
        <b>GOVERNING LAW AND VENUE:</b> Participant agrees that: (a) any and all
        disputes, claims and causes of action arising out of, or connected with,
        the Sweepstakes or any prize awarded shall be resolved individually
        without resort to any form of class action, and exclusively by the
        appropriate courts located Los Angeles County, California; and (b) any
        and all claims, judgments, and awards shall be limited to actual
        out-of-pocket costs incurred, including costs associated with entering
        the Sweepstakes, but in no event, attorneys’ fees. All issues and
        questions concerning the construction, validity, interpretation and
        enforceability of these Official Rules, your rights and obligations, or
        the rights and obligations of Sponsor in connection with this
        Sweepstakes, shall be governed by and construed in accordance with, the
        laws of the state of California, without giving effect to any choice of
        law or conflict of law rules.
      </Font>
    </>
  )
}

export default SweepstakesRules
